import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { ETenant } from '../../../../json_query';
import { changeTenant } from '../../../state/advanced/tenants';
import { InlineParam, Row } from '../markup';

export interface ITenantsProps {
  tenants: ETenant[];
  onTenantChanged(param: ETenant, value: boolean): void;
}

export const tenants: React.StatelessComponent<ITenantsProps> = props => (
  <Row title="Состав съемщиков">
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onTenantChanged(ETenant.Any, value)}
        value={props.tenants.indexOf(ETenant.Any) !== -1}
      >
        Любой
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onTenantChanged(ETenant.Family, value)}
        value={props.tenants.indexOf(ETenant.Family) !== -1}
      >
        Семья
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onTenantChanged(ETenant.Man, value)}
        value={props.tenants.indexOf(ETenant.Man) !== -1}
      >
        Мужчина
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onTenantChanged(ETenant.Woman, value)}
        value={props.tenants.indexOf(ETenant.Woman) !== -1}
      >
        Женщина
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    tenants: (state.filters.jsonQuery.composition && state.filters.jsonQuery.composition.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onTenantChanged: (param: ETenant, value: boolean) => {
      dispatch(changeTenant(param, value));
    },
  }),
)(tenants);
